const HOME = "/home";
const UUID_CANONICO = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

interface LocalizacaoDoApp {
  pathname: string;
  search: string;
}

/**
 * Reduz a URL protegida ao único conteúdo de deep link que deve sobreviver ao
 * login. Outros parâmetros podem carregar dados privados e são descartados.
 */
export function destinoAposLoginDaRota({ pathname, search }: LocalizacaoDoApp): string {
  if (pathname !== HOME) return HOME;

  const params = new URLSearchParams(search);
  const intencoes = params.getAll("abrir");
  if (intencoes.length !== 1) return HOME;
  if (intencoes[0] !== "marcacao") return HOME;
  const referencias = params.getAll("meal_ref");
  if (referencias.length === 0) return `${HOME}?abrir=marcacao`;
  if (referencias.length !== 1 || !UUID_CANONICO.test(referencias[0])) return HOME;
  return `${HOME}?abrir=marcacao&meal_ref=${referencias[0]}`;
}

/** Valida novamente o valor guardado no estado de navegação antes de usá-lo. */
export function destinoAposLoginDoEstado(state: unknown): string {
  if (!state || typeof state !== "object" || Array.isArray(state)) return HOME;

  const destino = (state as Record<string, unknown>).postLoginReturnTo;
  if (typeof destino !== "string") return HOME;
  if (destino === `${HOME}?abrir=marcacao`) {
    return destino;
  }
  const match = destino.match(/^\/home\?abrir=marcacao&meal_ref=([0-9a-f-]+)$/);
  return match && UUID_CANONICO.test(match[1]) ? destino : HOME;
}
